export default "__VITE_PUBLIC_ASSET__0d50f8e5__"